export default __webpack_public_path__ + "static/media/logo2.6b4c7a42.svg";